/* eslint-disable */
// source: payment_gateway.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.billing.private.paymentgateway.ApiUrl', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.BraintreeMerchantAccount', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CompleteEnableSCARequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CompleteEnableSCAResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateAdyenGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateAdyenGatewayResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateCardConnectRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateCardConnectResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateIxopayGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateIxopayGatewayResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateNMIGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateNMIGatewayResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreatePaymentCloudRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreatePaymentCloudResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.Data', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.DeletePaymentGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.DeletePaymentGatewayResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.ExtraStuff', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.PaymentGateTypes', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.Metadata', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.PaymentMethod', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.Response', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.ShippingAddress', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.StartEnableSCARequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.StartEnableSCAResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.Transaction', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateCardConnectRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateCardConnectResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateNMIGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateNMIGatewayResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdatePaymentCloudRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdatePaymentCloudResponse', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateStripeGatewayRequest', null, global);
goog.exportSymbol('proto.billing.private.paymentgateway.UpdateStripeGatewayResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.displayName = 'proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse.displayName = 'proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.StartEnableSCARequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.StartEnableSCARequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.StartEnableSCARequest.displayName = 'proto.billing.private.paymentgateway.StartEnableSCARequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.StartEnableSCAResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.StartEnableSCAResponse.displayName = 'proto.billing.private.paymentgateway.StartEnableSCAResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CompleteEnableSCARequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CompleteEnableSCARequest.displayName = 'proto.billing.private.paymentgateway.CompleteEnableSCARequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CompleteEnableSCAResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CompleteEnableSCAResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CompleteEnableSCAResponse.displayName = 'proto.billing.private.paymentgateway.CompleteEnableSCAResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.displayName = 'proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse.displayName = 'proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateStripeGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.displayName = 'proto.billing.private.paymentgateway.UpdateStripeGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateStripeGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateStripeGatewayResponse.displayName = 'proto.billing.private.paymentgateway.UpdateStripeGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.displayName = 'proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse.displayName = 'proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.displayName = 'proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse.displayName = 'proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.displayName = 'proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.repeatedFields_, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.displayName = 'proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.displayName = 'proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse.displayName = 'proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateAdyenGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.displayName = 'proto.billing.private.paymentgateway.CreateAdyenGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateAdyenGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateAdyenGatewayResponse.displayName = 'proto.billing.private.paymentgateway.CreateAdyenGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.displayName = 'proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse.displayName = 'proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.displayName = 'proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse.displayName = 'proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.displayName = 'proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse.displayName = 'proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateIxopayGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.displayName = 'proto.billing.private.paymentgateway.CreateIxopayGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateIxopayGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateIxopayGatewayResponse.displayName = 'proto.billing.private.paymentgateway.CreateIxopayGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.displayName = 'proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse.displayName = 'proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateNMIGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateNMIGatewayRequest.displayName = 'proto.billing.private.paymentgateway.CreateNMIGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateNMIGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateNMIGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateNMIGatewayResponse.displayName = 'proto.billing.private.paymentgateway.CreateNMIGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateNMIGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.displayName = 'proto.billing.private.paymentgateway.UpdateNMIGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateNMIGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateNMIGatewayResponse.displayName = 'proto.billing.private.paymentgateway.UpdateNMIGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateCardConnectRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateCardConnectRequest.displayName = 'proto.billing.private.paymentgateway.CreateCardConnectRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreateCardConnectResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreateCardConnectResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreateCardConnectResponse.displayName = 'proto.billing.private.paymentgateway.CreateCardConnectResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateCardConnectRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateCardConnectRequest.displayName = 'proto.billing.private.paymentgateway.UpdateCardConnectRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdateCardConnectResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdateCardConnectResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdateCardConnectResponse.displayName = 'proto.billing.private.paymentgateway.UpdateCardConnectResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreatePaymentCloudRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreatePaymentCloudRequest.displayName = 'proto.billing.private.paymentgateway.CreatePaymentCloudRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.CreatePaymentCloudResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.CreatePaymentCloudResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.CreatePaymentCloudResponse.displayName = 'proto.billing.private.paymentgateway.CreatePaymentCloudResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdatePaymentCloudRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.displayName = 'proto.billing.private.paymentgateway.UpdatePaymentCloudRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.UpdatePaymentCloudResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.UpdatePaymentCloudResponse.displayName = 'proto.billing.private.paymentgateway.UpdatePaymentCloudResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.DeletePaymentGatewayRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.DeletePaymentGatewayRequest.displayName = 'proto.billing.private.paymentgateway.DeletePaymentGatewayRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.DeletePaymentGatewayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.DeletePaymentGatewayResponse.displayName = 'proto.billing.private.paymentgateway.DeletePaymentGatewayResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.BraintreeMerchantAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.BraintreeMerchantAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.BraintreeMerchantAccount.displayName = 'proto.billing.private.paymentgateway.BraintreeMerchantAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest.displayName = 'proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse.displayName = 'proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.Transaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.paymentgateway.Transaction.repeatedFields_, null);
};
goog.inherits(proto.billing.private.paymentgateway.Transaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.Transaction.displayName = 'proto.billing.private.paymentgateway.Transaction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.Response.displayName = 'proto.billing.private.paymentgateway.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.ShippingAddress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.ShippingAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.ShippingAddress.displayName = 'proto.billing.private.paymentgateway.ShippingAddress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.ApiUrl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.paymentgateway.ApiUrl.repeatedFields_, null);
};
goog.inherits(proto.billing.private.paymentgateway.ApiUrl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.ApiUrl.displayName = 'proto.billing.private.paymentgateway.ApiUrl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.PaymentMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billing.private.paymentgateway.PaymentMethod.repeatedFields_, null);
};
goog.inherits(proto.billing.private.paymentgateway.PaymentMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.PaymentMethod.displayName = 'proto.billing.private.paymentgateway.PaymentMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.Data = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.Data, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.Data.displayName = 'proto.billing.private.paymentgateway.Data';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.ExtraStuff = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.ExtraStuff, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.ExtraStuff.displayName = 'proto.billing.private.paymentgateway.ExtraStuff';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billing.private.paymentgateway.Metadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billing.private.paymentgateway.Metadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billing.private.paymentgateway.Metadata.displayName = 'proto.billing.private.paymentgateway.Metadata';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentGatewayType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest}
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest;
  return proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest}
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {!proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.PaymentGateTypes} */ (reader.readEnum());
      msg.setPaymentGatewayType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentGatewayType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.PaymentGateTypes = {
  SPREEDLY_TEST: 0,
  STRIPE: 1,
  CHECKOUT_DOT_COM: 2,
  BRAINTREE: 3,
  ADYEN: 4,
  AUTHORIZE_DOT_NET: 5,
  IXOPAY: 6,
  NMI: 7,
  CARD_CONNECT: 8,
  PAYMENT_CLOUD: 9,
  STRIPE_INTENT: 10
};

/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest} returns this
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PaymentGateTypes payment_gateway_type = 2;
 * @return {!proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.PaymentGateTypes}
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.prototype.getPaymentGatewayType = function() {
  return /** @type {!proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.PaymentGateTypes} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.PaymentGateTypes} value
 * @return {!proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest} returns this
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsRequest.prototype.setPaymentGatewayType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    minimumChargeAmount: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse}
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse;
  return proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse}
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinimumChargeAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMinimumChargeAmount();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string minimum_charge_amount = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse.prototype.getMinimumChargeAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse} returns this
 */
proto.billing.private.paymentgateway.GetGatewayScaDetailsResponse.prototype.setMinimumChargeAmount = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.StartEnableSCARequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.StartEnableSCARequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    testCardFullName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    testCardPaymentMethodToken: jspb.Message.getFieldWithDefault(msg, 4, ""),
    webhookId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    webhookSigningSecret: jspb.Message.getFieldWithDefault(msg, 6, ""),
    browserInfo: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.StartEnableSCARequest}
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.StartEnableSCARequest;
  return proto.billing.private.paymentgateway.StartEnableSCARequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.StartEnableSCARequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.StartEnableSCARequest}
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTestCardFullName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTestCardPaymentMethodToken(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebhookId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebhookSigningSecret(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrowserInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.StartEnableSCARequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.StartEnableSCARequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTestCardFullName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTestCardPaymentMethodToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getWebhookId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getWebhookSigningSecret();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBrowserInfo();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.StartEnableSCARequest} returns this
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 payment_gateway_id = 2;
 * @return {number}
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.StartEnableSCARequest} returns this
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string test_card_full_name = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.getTestCardFullName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.StartEnableSCARequest} returns this
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.setTestCardFullName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string test_card_payment_method_token = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.getTestCardPaymentMethodToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.StartEnableSCARequest} returns this
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.setTestCardPaymentMethodToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string webhook_id = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.getWebhookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.StartEnableSCARequest} returns this
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.setWebhookId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string webhook_signing_secret = 6;
 * @return {string}
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.getWebhookSigningSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.StartEnableSCARequest} returns this
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.setWebhookSigningSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string browser_info = 7;
 * @return {string}
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.getBrowserInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.StartEnableSCARequest} returns this
 */
proto.billing.private.paymentgateway.StartEnableSCARequest.prototype.setBrowserInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.StartEnableSCAResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.StartEnableSCAResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isThreeDsRequired: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    scaTransactionId: (f = msg.getScaTransactionId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    transactionToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
    transactionCheckoutUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    transactionCheckoutForm: jspb.Message.getFieldWithDefault(msg, 5, ""),
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.StartEnableSCAResponse}
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.StartEnableSCAResponse;
  return proto.billing.private.paymentgateway.StartEnableSCAResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.StartEnableSCAResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.StartEnableSCAResponse}
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsThreeDsRequired(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setScaTransactionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionToken(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionCheckoutUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionCheckoutForm(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.StartEnableSCAResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.StartEnableSCAResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsThreeDsRequired();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getScaTransactionId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getTransactionToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTransactionCheckoutUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTransactionCheckoutForm();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional bool is_three_ds_required = 1;
 * @return {boolean}
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.getIsThreeDsRequired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.paymentgateway.StartEnableSCAResponse} returns this
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.setIsThreeDsRequired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional google.protobuf.Int32Value sca_transaction_id = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.getScaTransactionId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.billing.private.paymentgateway.StartEnableSCAResponse} returns this
*/
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.setScaTransactionId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.StartEnableSCAResponse} returns this
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.clearScaTransactionId = function() {
  return this.setScaTransactionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.hasScaTransactionId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string transaction_token = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.getTransactionToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.StartEnableSCAResponse} returns this
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.setTransactionToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string transaction_checkout_url = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.getTransactionCheckoutUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.StartEnableSCAResponse} returns this
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.setTransactionCheckoutUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string transaction_checkout_form = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.getTransactionCheckoutForm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.StartEnableSCAResponse} returns this
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.setTransactionCheckoutForm = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 payment_gateway_id = 6;
 * @return {number}
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.StartEnableSCAResponse} returns this
 */
proto.billing.private.paymentgateway.StartEnableSCAResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CompleteEnableSCARequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CompleteEnableSCARequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    scaTransactionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    isSuccessful: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CompleteEnableSCARequest}
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CompleteEnableSCARequest;
  return proto.billing.private.paymentgateway.CompleteEnableSCARequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CompleteEnableSCARequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CompleteEnableSCARequest}
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScaTransactionId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuccessful(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CompleteEnableSCARequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CompleteEnableSCARequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScaTransactionId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getIsSuccessful();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CompleteEnableSCARequest} returns this
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 sca_transaction_id = 2;
 * @return {number}
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest.prototype.getScaTransactionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.CompleteEnableSCARequest} returns this
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest.prototype.setScaTransactionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 payment_gateway_id = 3;
 * @return {number}
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.CompleteEnableSCARequest} returns this
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool is_successful = 4;
 * @return {boolean}
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest.prototype.getIsSuccessful = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.paymentgateway.CompleteEnableSCARequest} returns this
 */
proto.billing.private.paymentgateway.CompleteEnableSCARequest.prototype.setIsSuccessful = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CompleteEnableSCAResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CompleteEnableSCAResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CompleteEnableSCAResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CompleteEnableSCAResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CompleteEnableSCAResponse}
 */
proto.billing.private.paymentgateway.CompleteEnableSCAResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CompleteEnableSCAResponse;
  return proto.billing.private.paymentgateway.CompleteEnableSCAResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CompleteEnableSCAResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CompleteEnableSCAResponse}
 */
proto.billing.private.paymentgateway.CompleteEnableSCAResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CompleteEnableSCAResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CompleteEnableSCAResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CompleteEnableSCAResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CompleteEnableSCAResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    stripeUserId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    refreshToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accessToken: jspb.Message.getFieldWithDefault(msg, 4, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest}
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest;
  return proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest}
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStripeUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefreshToken(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessToken(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStripeUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRefreshToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccessToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string stripe_user_id = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.prototype.getStripeUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.prototype.setStripeUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string refresh_token = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.prototype.getRefreshToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.prototype.setRefreshToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string access_token = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.prototype.getAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.prototype.setAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string display_name = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse}
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse;
  return proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse}
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateStripeIntentGatewayResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateStripeGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateStripeGatewayRequest}
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateStripeGatewayRequest;
  return proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateStripeGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateStripeGatewayRequest}
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateStripeGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateStripeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 payment_gateway_id = 2;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateStripeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateStripeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateStripeGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateStripeGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateStripeGatewayResponse}
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateStripeGatewayResponse;
  return proto.billing.private.paymentgateway.UpdateStripeGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateStripeGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateStripeGatewayResponse}
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateStripeGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateStripeGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateStripeGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    secretKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest}
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest;
  return proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest}
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecretKey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSecretKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string secret_key = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.prototype.getSecretKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.prototype.setSecretKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse}
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse;
  return proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse}
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateCheckoutDotComGatewayResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    secretKey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest}
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest;
  return proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest}
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecretKey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSecretKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 payment_gateway_id = 2;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string secret_key = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.prototype.getSecretKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.prototype.setSecretKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string display_name = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse}
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse;
  return proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse}
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.UpdateCheckoutDotComGatewayResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    merchantId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    publicKey: jspb.Message.getFieldWithDefault(msg, 4, ""),
    privateKey: jspb.Message.getFieldWithDefault(msg, 5, ""),
    merchantAccountId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest;
  return proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicKey(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrivateKey(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMerchantId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPublicKey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPrivateKey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMerchantAccountId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string merchant_id = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.prototype.getMerchantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.prototype.setMerchantId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string public_key = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.prototype.getPublicKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.prototype.setPublicKey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string private_key = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.prototype.getPrivateKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.prototype.setPrivateKey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string merchant_account_id = 6;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.prototype.getMerchantAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayRequest.prototype.setMerchantAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isSaved: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    merchantAccountsList: jspb.Message.toObjectList(msg.getMerchantAccountsList(),
    proto.billing.private.paymentgateway.BraintreeMerchantAccount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse;
  return proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSaved(value);
      break;
    case 4:
      var value = new proto.billing.private.paymentgateway.BraintreeMerchantAccount;
      reader.readMessage(value,proto.billing.private.paymentgateway.BraintreeMerchantAccount.deserializeBinaryFromReader);
      msg.addMerchantAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsSaved();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getMerchantAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.billing.private.paymentgateway.BraintreeMerchantAccount.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_saved = 3;
 * @return {boolean}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.prototype.getIsSaved = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.prototype.setIsSaved = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated BraintreeMerchantAccount merchant_accounts = 4;
 * @return {!Array<!proto.billing.private.paymentgateway.BraintreeMerchantAccount>}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.prototype.getMerchantAccountsList = function() {
  return /** @type{!Array<!proto.billing.private.paymentgateway.BraintreeMerchantAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billing.private.paymentgateway.BraintreeMerchantAccount, 4));
};


/**
 * @param {!Array<!proto.billing.private.paymentgateway.BraintreeMerchantAccount>} value
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse} returns this
*/
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.prototype.setMerchantAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.billing.private.paymentgateway.BraintreeMerchantAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing.private.paymentgateway.BraintreeMerchantAccount}
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.prototype.addMerchantAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.billing.private.paymentgateway.BraintreeMerchantAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateBraintreeGatewayResponse.prototype.clearMerchantAccountsList = function() {
  return this.setMerchantAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    merchantId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    publicKey: jspb.Message.getFieldWithDefault(msg, 5, ""),
    privateKey: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest;
  return proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicKey(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrivateKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMerchantId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPublicKey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPrivateKey();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 payment_gateway_id = 2;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string merchant_id = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.prototype.getMerchantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.prototype.setMerchantId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string public_key = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.prototype.getPublicKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.prototype.setPublicKey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string private_key = 6;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.prototype.getPrivateKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayRequest.prototype.setPrivateKey = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse;
  return proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.UpdateBraintreeGatewayResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateAdyenGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    username: jspb.Message.getFieldWithDefault(msg, 3, ""),
    password: jspb.Message.getFieldWithDefault(msg, 4, ""),
    merchantAccount: jspb.Message.getFieldWithDefault(msg, 5, ""),
    subdomain: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateAdyenGatewayRequest}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateAdyenGatewayRequest;
  return proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateAdyenGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateAdyenGatewayRequest}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantAccount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubdomain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateAdyenGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMerchantAccount();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSubdomain();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateAdyenGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateAdyenGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string username = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateAdyenGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string password = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateAdyenGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string merchant_account = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.prototype.getMerchantAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateAdyenGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.prototype.setMerchantAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string subdomain = 6;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.prototype.getSubdomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateAdyenGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayRequest.prototype.setSubdomain = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateAdyenGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateAdyenGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateAdyenGatewayResponse}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateAdyenGatewayResponse;
  return proto.billing.private.paymentgateway.CreateAdyenGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateAdyenGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateAdyenGatewayResponse}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateAdyenGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateAdyenGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.CreateAdyenGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateAdyenGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateAdyenGatewayResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    username: jspb.Message.getFieldWithDefault(msg, 4, ""),
    password: jspb.Message.getFieldWithDefault(msg, 5, ""),
    merchantAccount: jspb.Message.getFieldWithDefault(msg, 6, ""),
    subdomain: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest;
  return proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantAccount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubdomain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMerchantAccount();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSubdomain();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 payment_gateway_id = 2;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string username = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string password = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string merchant_account = 6;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.getMerchantAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.setMerchantAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string subdomain = 7;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.getSubdomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayRequest.prototype.setSubdomain = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse;
  return proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.UpdateAdyenGatewayResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    apiLoginId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    password: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest}
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest;
  return proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest}
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setApiLoginId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getApiLoginId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string api_login_id = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.prototype.getApiLoginId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.prototype.setApiLoginId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string password = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse}
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse;
  return proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse}
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateAuthorizeDotNetGatewayResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    apiLoginId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    password: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest;
  return proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setApiLoginId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getApiLoginId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 payment_gateway_id = 2;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string api_login_id = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.prototype.getApiLoginId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.prototype.setApiLoginId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string password = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse;
  return proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.UpdateAuthorizeDotNetGatewayResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateIxopayGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    username: jspb.Message.getFieldWithDefault(msg, 3, ""),
    apiKey: jspb.Message.getFieldWithDefault(msg, 4, ""),
    password: jspb.Message.getFieldWithDefault(msg, 5, ""),
    secret: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateIxopayGatewayRequest}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateIxopayGatewayRequest;
  return proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateIxopayGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateIxopayGatewayRequest}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setApiKey(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateIxopayGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getApiKey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSecret();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateIxopayGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateIxopayGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string username = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateIxopayGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string api_key = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.prototype.getApiKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateIxopayGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.prototype.setApiKey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string password = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateIxopayGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string secret = 6;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.prototype.getSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateIxopayGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayRequest.prototype.setSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateIxopayGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateIxopayGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateIxopayGatewayResponse}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateIxopayGatewayResponse;
  return proto.billing.private.paymentgateway.CreateIxopayGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateIxopayGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateIxopayGatewayResponse}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateIxopayGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateIxopayGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.CreateIxopayGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateIxopayGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateIxopayGatewayResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    username: jspb.Message.getFieldWithDefault(msg, 4, ""),
    apiKey: jspb.Message.getFieldWithDefault(msg, 5, ""),
    password: jspb.Message.getFieldWithDefault(msg, 6, ""),
    secret: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest;
  return proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setApiKey(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getApiKey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSecret();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 payment_gateway_id = 2;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string username = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string api_key = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.getApiKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.setApiKey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string password = 6;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string secret = 7;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.getSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayRequest.prototype.setSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse;
  return proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.UpdateIxopayGatewayResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateNMIGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateNMIGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    login: jspb.Message.getFieldWithDefault(msg, 3, ""),
    password: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateNMIGatewayRequest}
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateNMIGatewayRequest;
  return proto.billing.private.paymentgateway.CreateNMIGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateNMIGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateNMIGatewayRequest}
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogin(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateNMIGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateNMIGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLogin();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateNMIGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateNMIGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string login = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest.prototype.getLogin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateNMIGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest.prototype.setLogin = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string password = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateNMIGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.CreateNMIGatewayRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateNMIGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateNMIGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateNMIGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateNMIGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateNMIGatewayResponse}
 */
proto.billing.private.paymentgateway.CreateNMIGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateNMIGatewayResponse;
  return proto.billing.private.paymentgateway.CreateNMIGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateNMIGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateNMIGatewayResponse}
 */
proto.billing.private.paymentgateway.CreateNMIGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateNMIGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateNMIGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateNMIGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateNMIGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.CreateNMIGatewayResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.CreateNMIGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateNMIGatewayResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateNMIGatewayResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateNMIGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.CreateNMIGatewayResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateNMIGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    login: jspb.Message.getFieldWithDefault(msg, 4, ""),
    password: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateNMIGatewayRequest}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateNMIGatewayRequest;
  return proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateNMIGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateNMIGatewayRequest}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogin(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateNMIGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLogin();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateNMIGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 payment_gateway_id = 2;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateNMIGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateNMIGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string login = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.prototype.getLogin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateNMIGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.prototype.setLogin = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string password = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateNMIGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateNMIGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateNMIGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateNMIGatewayResponse}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateNMIGatewayResponse;
  return proto.billing.private.paymentgateway.UpdateNMIGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateNMIGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateNMIGatewayResponse}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateNMIGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateNMIGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateNMIGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateNMIGatewayResponse} returns this
 */
proto.billing.private.paymentgateway.UpdateNMIGatewayResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateCardConnectRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateCardConnectRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    login: jspb.Message.getFieldWithDefault(msg, 3, ""),
    password: jspb.Message.getFieldWithDefault(msg, 4, ""),
    merchantId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateCardConnectRequest}
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateCardConnectRequest;
  return proto.billing.private.paymentgateway.CreateCardConnectRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateCardConnectRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateCardConnectRequest}
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogin(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateCardConnectRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateCardConnectRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLogin();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMerchantId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateCardConnectRequest} returns this
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateCardConnectRequest} returns this
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string login = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.prototype.getLogin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateCardConnectRequest} returns this
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.prototype.setLogin = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string password = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateCardConnectRequest} returns this
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string merchant_id = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.prototype.getMerchantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateCardConnectRequest} returns this
 */
proto.billing.private.paymentgateway.CreateCardConnectRequest.prototype.setMerchantId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreateCardConnectResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreateCardConnectResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreateCardConnectResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateCardConnectResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreateCardConnectResponse}
 */
proto.billing.private.paymentgateway.CreateCardConnectResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreateCardConnectResponse;
  return proto.billing.private.paymentgateway.CreateCardConnectResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreateCardConnectResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreateCardConnectResponse}
 */
proto.billing.private.paymentgateway.CreateCardConnectResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreateCardConnectResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreateCardConnectResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreateCardConnectResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreateCardConnectResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.CreateCardConnectResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.CreateCardConnectResponse} returns this
 */
proto.billing.private.paymentgateway.CreateCardConnectResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreateCardConnectResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreateCardConnectResponse} returns this
 */
proto.billing.private.paymentgateway.CreateCardConnectResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateCardConnectRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateCardConnectRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    login: jspb.Message.getFieldWithDefault(msg, 4, ""),
    password: jspb.Message.getFieldWithDefault(msg, 5, ""),
    merchantId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateCardConnectRequest}
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateCardConnectRequest;
  return proto.billing.private.paymentgateway.UpdateCardConnectRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateCardConnectRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateCardConnectRequest}
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogin(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateCardConnectRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateCardConnectRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLogin();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMerchantId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateCardConnectRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 payment_gateway_id = 2;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateCardConnectRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateCardConnectRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string login = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.prototype.getLogin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateCardConnectRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.prototype.setLogin = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string password = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateCardConnectRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string merchant_id = 6;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.prototype.getMerchantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateCardConnectRequest} returns this
 */
proto.billing.private.paymentgateway.UpdateCardConnectRequest.prototype.setMerchantId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdateCardConnectResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdateCardConnectResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdateCardConnectResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateCardConnectResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdateCardConnectResponse}
 */
proto.billing.private.paymentgateway.UpdateCardConnectResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdateCardConnectResponse;
  return proto.billing.private.paymentgateway.UpdateCardConnectResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdateCardConnectResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdateCardConnectResponse}
 */
proto.billing.private.paymentgateway.UpdateCardConnectResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdateCardConnectResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdateCardConnectResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdateCardConnectResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdateCardConnectResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdateCardConnectResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdateCardConnectResponse} returns this
 */
proto.billing.private.paymentgateway.UpdateCardConnectResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdateCardConnectResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdateCardConnectResponse} returns this
 */
proto.billing.private.paymentgateway.UpdateCardConnectResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreatePaymentCloudRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreatePaymentCloudRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    apiLoginId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    transactionKey: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreatePaymentCloudRequest}
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreatePaymentCloudRequest;
  return proto.billing.private.paymentgateway.CreatePaymentCloudRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreatePaymentCloudRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreatePaymentCloudRequest}
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setApiLoginId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreatePaymentCloudRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreatePaymentCloudRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getApiLoginId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTransactionKey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreatePaymentCloudRequest} returns this
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreatePaymentCloudRequest} returns this
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string api_login_id = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest.prototype.getApiLoginId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreatePaymentCloudRequest} returns this
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest.prototype.setApiLoginId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string transaction_key = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest.prototype.getTransactionKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreatePaymentCloudRequest} returns this
 */
proto.billing.private.paymentgateway.CreatePaymentCloudRequest.prototype.setTransactionKey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.CreatePaymentCloudResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.CreatePaymentCloudResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.CreatePaymentCloudResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreatePaymentCloudResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.CreatePaymentCloudResponse}
 */
proto.billing.private.paymentgateway.CreatePaymentCloudResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.CreatePaymentCloudResponse;
  return proto.billing.private.paymentgateway.CreatePaymentCloudResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.CreatePaymentCloudResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.CreatePaymentCloudResponse}
 */
proto.billing.private.paymentgateway.CreatePaymentCloudResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.CreatePaymentCloudResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.CreatePaymentCloudResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.CreatePaymentCloudResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.CreatePaymentCloudResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.CreatePaymentCloudResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.CreatePaymentCloudResponse} returns this
 */
proto.billing.private.paymentgateway.CreatePaymentCloudResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.CreatePaymentCloudResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.CreatePaymentCloudResponse} returns this
 */
proto.billing.private.paymentgateway.CreatePaymentCloudResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdatePaymentCloudRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    apiLoginId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    transactionKey: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdatePaymentCloudRequest}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdatePaymentCloudRequest;
  return proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdatePaymentCloudRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdatePaymentCloudRequest}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setApiLoginId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdatePaymentCloudRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getApiLoginId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTransactionKey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdatePaymentCloudRequest} returns this
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 payment_gateway_id = 2;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdatePaymentCloudRequest} returns this
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string display_name = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdatePaymentCloudRequest} returns this
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string api_login_id = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.prototype.getApiLoginId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdatePaymentCloudRequest} returns this
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.prototype.setApiLoginId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string transaction_key = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.prototype.getTransactionKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdatePaymentCloudRequest} returns this
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudRequest.prototype.setTransactionKey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.UpdatePaymentCloudResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.UpdatePaymentCloudResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.UpdatePaymentCloudResponse}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.UpdatePaymentCloudResponse;
  return proto.billing.private.paymentgateway.UpdatePaymentCloudResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.UpdatePaymentCloudResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.UpdatePaymentCloudResponse}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.UpdatePaymentCloudResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.UpdatePaymentCloudResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudResponse.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.UpdatePaymentCloudResponse} returns this
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudResponse.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.UpdatePaymentCloudResponse} returns this
 */
proto.billing.private.paymentgateway.UpdatePaymentCloudResponse.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.DeletePaymentGatewayRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.DeletePaymentGatewayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentGatewayId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    companyDomain: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.DeletePaymentGatewayRequest}
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.DeletePaymentGatewayRequest;
  return proto.billing.private.paymentgateway.DeletePaymentGatewayRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.DeletePaymentGatewayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.DeletePaymentGatewayRequest}
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentGatewayId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.DeletePaymentGatewayRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.DeletePaymentGatewayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentGatewayId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 payment_gateway_id = 1;
 * @return {number}
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayRequest.prototype.getPaymentGatewayId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.DeletePaymentGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayRequest.prototype.setPaymentGatewayId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string company_domain = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.DeletePaymentGatewayRequest} returns this
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.DeletePaymentGatewayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.DeletePaymentGatewayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.DeletePaymentGatewayResponse}
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.DeletePaymentGatewayResponse;
  return proto.billing.private.paymentgateway.DeletePaymentGatewayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.DeletePaymentGatewayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.DeletePaymentGatewayResponse}
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.DeletePaymentGatewayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.DeletePaymentGatewayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.DeletePaymentGatewayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.BraintreeMerchantAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.BraintreeMerchantAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.BraintreeMerchantAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.BraintreeMerchantAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
    merchantAccountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    currencyIsoCode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.BraintreeMerchantAccount}
 */
proto.billing.private.paymentgateway.BraintreeMerchantAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.BraintreeMerchantAccount;
  return proto.billing.private.paymentgateway.BraintreeMerchantAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.BraintreeMerchantAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.BraintreeMerchantAccount}
 */
proto.billing.private.paymentgateway.BraintreeMerchantAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyIsoCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.BraintreeMerchantAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.BraintreeMerchantAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.BraintreeMerchantAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.BraintreeMerchantAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMerchantAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrencyIsoCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string merchant_account_id = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.BraintreeMerchantAccount.prototype.getMerchantAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.BraintreeMerchantAccount} returns this
 */
proto.billing.private.paymentgateway.BraintreeMerchantAccount.prototype.setMerchantAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string currency_iso_code = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.BraintreeMerchantAccount.prototype.getCurrencyIsoCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.BraintreeMerchantAccount} returns this
 */
proto.billing.private.paymentgateway.BraintreeMerchantAccount.prototype.setCurrencyIsoCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyDomain: jspb.Message.getFieldWithDefault(msg, 1, ""),
    transactionToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest}
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest;
  return proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest}
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyDomain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTransactionToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string company_domain = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest.prototype.getCompanyDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest} returns this
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest.prototype.setCompanyDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string transaction_token = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest.prototype.getTransactionToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest} returns this
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionRequest.prototype.setTransactionToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    transaction: (f = msg.getTransaction()) && proto.billing.private.paymentgateway.Transaction.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse}
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse;
  return proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse}
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billing.private.paymentgateway.Transaction;
      reader.readMessage(value,proto.billing.private.paymentgateway.Transaction.deserializeBinaryFromReader);
      msg.setTransaction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransaction();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billing.private.paymentgateway.Transaction.serializeBinaryToWriter
    );
  }
};


/**
 * optional Transaction transaction = 1;
 * @return {?proto.billing.private.paymentgateway.Transaction}
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse.prototype.getTransaction = function() {
  return /** @type{?proto.billing.private.paymentgateway.Transaction} */ (
    jspb.Message.getWrapperField(this, proto.billing.private.paymentgateway.Transaction, 1));
};


/**
 * @param {?proto.billing.private.paymentgateway.Transaction|undefined} value
 * @return {!proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse} returns this
*/
proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse.prototype.setTransaction = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse} returns this
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse.prototype.clearTransaction = function() {
  return this.setTransaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.GetSpreedlyTransactionResponse.prototype.hasTransaction = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.paymentgateway.Transaction.repeatedFields_ = [25];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.Transaction.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.Transaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.Transaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.Transaction.toObject = function(includeInstance, msg) {
  var f, obj = {
    onTestGateway: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    createdOn: (f = msg.getCreatedOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedOn: (f = msg.getUpdatedOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    succeeded: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    state: jspb.Message.getFieldWithDefault(msg, 5, ""),
    token: jspb.Message.getFieldWithDefault(msg, 6, ""),
    transactionType: jspb.Message.getFieldWithDefault(msg, 7, ""),
    orderId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    ip: jspb.Message.getFieldWithDefault(msg, 9, ""),
    description: jspb.Message.getFieldWithDefault(msg, 10, ""),
    email: jspb.Message.getFieldWithDefault(msg, 11, ""),
    merchantNameDescriptor: jspb.Message.getFieldWithDefault(msg, 12, ""),
    gatewaySpecificFields: jspb.Message.getFieldWithDefault(msg, 13, ""),
    gatewayTransactionId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    gatewayLatencyMs: (f = msg.getGatewayLatencyMs()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
    amount: jspb.Message.getFieldWithDefault(msg, 16, 0),
    currencyCode: jspb.Message.getFieldWithDefault(msg, 17, ""),
    retainOnSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
    paymentMethodAdded: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
    messageKey: jspb.Message.getFieldWithDefault(msg, 20, ""),
    message: jspb.Message.getFieldWithDefault(msg, 21, ""),
    gatewayType: jspb.Message.getFieldWithDefault(msg, 22, ""),
    response: (f = msg.getResponse()) && proto.billing.private.paymentgateway.Response.toObject(includeInstance, f),
    shippingAddress: (f = msg.getShippingAddress()) && proto.billing.private.paymentgateway.ShippingAddress.toObject(includeInstance, f),
    apiUrlsList: jspb.Message.toObjectList(msg.getApiUrlsList(),
    proto.billing.private.paymentgateway.ApiUrl.toObject, includeInstance),
    paymentMethod: (f = msg.getPaymentMethod()) && proto.billing.private.paymentgateway.PaymentMethod.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.Transaction}
 */
proto.billing.private.paymentgateway.Transaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.Transaction;
  return proto.billing.private.paymentgateway.Transaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.Transaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.Transaction}
 */
proto.billing.private.paymentgateway.Transaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnTestGateway(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedOn(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedOn(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSucceeded(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setIp(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantNameDescriptor(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setGatewaySpecificFields(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setGatewayTransactionId(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setGatewayLatencyMs(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyCode(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRetainOnSuccess(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaymentMethodAdded(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessageKey(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setGatewayType(value);
      break;
    case 23:
      var value = new proto.billing.private.paymentgateway.Response;
      reader.readMessage(value,proto.billing.private.paymentgateway.Response.deserializeBinaryFromReader);
      msg.setResponse(value);
      break;
    case 24:
      var value = new proto.billing.private.paymentgateway.ShippingAddress;
      reader.readMessage(value,proto.billing.private.paymentgateway.ShippingAddress.deserializeBinaryFromReader);
      msg.setShippingAddress(value);
      break;
    case 25:
      var value = new proto.billing.private.paymentgateway.ApiUrl;
      reader.readMessage(value,proto.billing.private.paymentgateway.ApiUrl.deserializeBinaryFromReader);
      msg.addApiUrls(value);
      break;
    case 26:
      var value = new proto.billing.private.paymentgateway.PaymentMethod;
      reader.readMessage(value,proto.billing.private.paymentgateway.PaymentMethod.deserializeBinaryFromReader);
      msg.setPaymentMethod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.Transaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.Transaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.Transaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.Transaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOnTestGateway();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCreatedOn();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedOn();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSucceeded();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTransactionType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIp();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getMerchantNameDescriptor();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getGatewaySpecificFields();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getGatewayTransactionId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getGatewayLatencyMs();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getRetainOnSuccess();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getPaymentMethodAdded();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getMessageKey();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getGatewayType();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getResponse();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.billing.private.paymentgateway.Response.serializeBinaryToWriter
    );
  }
  f = message.getShippingAddress();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      proto.billing.private.paymentgateway.ShippingAddress.serializeBinaryToWriter
    );
  }
  f = message.getApiUrlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      25,
      f,
      proto.billing.private.paymentgateway.ApiUrl.serializeBinaryToWriter
    );
  }
  f = message.getPaymentMethod();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      proto.billing.private.paymentgateway.PaymentMethod.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool on_test_gateway = 1;
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getOnTestGateway = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setOnTestGateway = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created_on = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getCreatedOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
*/
proto.billing.private.paymentgateway.Transaction.prototype.setCreatedOn = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.clearCreatedOn = function() {
  return this.setCreatedOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Transaction.prototype.hasCreatedOn = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp updated_on = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getUpdatedOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
*/
proto.billing.private.paymentgateway.Transaction.prototype.setUpdatedOn = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.clearUpdatedOn = function() {
  return this.setUpdatedOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Transaction.prototype.hasUpdatedOn = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool succeeded = 4;
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getSucceeded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setSucceeded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string state = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string token = 6;
 * @return {string}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string transaction_type = 7;
 * @return {string}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getTransactionType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setTransactionType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string order_id = 8;
 * @return {string}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string ip = 9;
 * @return {string}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setIp = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string description = 10;
 * @return {string}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string email = 11;
 * @return {string}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string merchant_name_descriptor = 12;
 * @return {string}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getMerchantNameDescriptor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setMerchantNameDescriptor = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string gateway_specific_fields = 13;
 * @return {string}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getGatewaySpecificFields = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setGatewaySpecificFields = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string gateway_transaction_id = 14;
 * @return {string}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getGatewayTransactionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setGatewayTransactionId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional google.protobuf.Int64Value gateway_latency_ms = 15;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getGatewayLatencyMs = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 15));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
*/
proto.billing.private.paymentgateway.Transaction.prototype.setGatewayLatencyMs = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.clearGatewayLatencyMs = function() {
  return this.setGatewayLatencyMs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Transaction.prototype.hasGatewayLatencyMs = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional int64 amount = 16;
 * @return {number}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string currency_code = 17;
 * @return {string}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional bool retain_on_success = 18;
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getRetainOnSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setRetainOnSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional bool payment_method_added = 19;
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getPaymentMethodAdded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setPaymentMethodAdded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional string message_key = 20;
 * @return {string}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getMessageKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setMessageKey = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string message = 21;
 * @return {string}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string gateway_type = 22;
 * @return {string}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getGatewayType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.setGatewayType = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional Response response = 23;
 * @return {?proto.billing.private.paymentgateway.Response}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getResponse = function() {
  return /** @type{?proto.billing.private.paymentgateway.Response} */ (
    jspb.Message.getWrapperField(this, proto.billing.private.paymentgateway.Response, 23));
};


/**
 * @param {?proto.billing.private.paymentgateway.Response|undefined} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
*/
proto.billing.private.paymentgateway.Transaction.prototype.setResponse = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.clearResponse = function() {
  return this.setResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Transaction.prototype.hasResponse = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional ShippingAddress shipping_address = 24;
 * @return {?proto.billing.private.paymentgateway.ShippingAddress}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getShippingAddress = function() {
  return /** @type{?proto.billing.private.paymentgateway.ShippingAddress} */ (
    jspb.Message.getWrapperField(this, proto.billing.private.paymentgateway.ShippingAddress, 24));
};


/**
 * @param {?proto.billing.private.paymentgateway.ShippingAddress|undefined} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
*/
proto.billing.private.paymentgateway.Transaction.prototype.setShippingAddress = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.clearShippingAddress = function() {
  return this.setShippingAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Transaction.prototype.hasShippingAddress = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * repeated ApiUrl api_urls = 25;
 * @return {!Array<!proto.billing.private.paymentgateway.ApiUrl>}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getApiUrlsList = function() {
  return /** @type{!Array<!proto.billing.private.paymentgateway.ApiUrl>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billing.private.paymentgateway.ApiUrl, 25));
};


/**
 * @param {!Array<!proto.billing.private.paymentgateway.ApiUrl>} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
*/
proto.billing.private.paymentgateway.Transaction.prototype.setApiUrlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 25, value);
};


/**
 * @param {!proto.billing.private.paymentgateway.ApiUrl=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing.private.paymentgateway.ApiUrl}
 */
proto.billing.private.paymentgateway.Transaction.prototype.addApiUrls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 25, opt_value, proto.billing.private.paymentgateway.ApiUrl, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.clearApiUrlsList = function() {
  return this.setApiUrlsList([]);
};


/**
 * optional PaymentMethod payment_method = 26;
 * @return {?proto.billing.private.paymentgateway.PaymentMethod}
 */
proto.billing.private.paymentgateway.Transaction.prototype.getPaymentMethod = function() {
  return /** @type{?proto.billing.private.paymentgateway.PaymentMethod} */ (
    jspb.Message.getWrapperField(this, proto.billing.private.paymentgateway.PaymentMethod, 26));
};


/**
 * @param {?proto.billing.private.paymentgateway.PaymentMethod|undefined} value
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
*/
proto.billing.private.paymentgateway.Transaction.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.Transaction} returns this
 */
proto.billing.private.paymentgateway.Transaction.prototype.clearPaymentMethod = function() {
  return this.setPaymentMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Transaction.prototype.hasPaymentMethod = function() {
  return jspb.Message.getField(this, 26) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    avsCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    avsMessage: jspb.Message.getFieldWithDefault(msg, 4, ""),
    cvvCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
    cvvMessage: jspb.Message.getFieldWithDefault(msg, 6, ""),
    pending: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    errorCode: jspb.Message.getFieldWithDefault(msg, 8, ""),
    errorDetail: jspb.Message.getFieldWithDefault(msg, 9, ""),
    cancelled: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    fraudReview: jspb.Message.getFieldWithDefault(msg, 11, ""),
    createdOn: (f = msg.getCreatedOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedOn: (f = msg.getUpdatedOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.Response}
 */
proto.billing.private.paymentgateway.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.Response;
  return proto.billing.private.paymentgateway.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.Response}
 */
proto.billing.private.paymentgateway.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvsCode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvsMessage(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCvvCode(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCvvMessage(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPending(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorCode(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorDetail(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCancelled(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFraudReview(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedOn(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedOn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAvsCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAvsMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCvvCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCvvMessage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPending();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getErrorCode();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getErrorDetail();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCancelled();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getFraudReview();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCreatedOn();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedOn();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Response.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.paymentgateway.Response} returns this
 */
proto.billing.private.paymentgateway.Response.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.Response.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Response} returns this
 */
proto.billing.private.paymentgateway.Response.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string avs_code = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.Response.prototype.getAvsCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Response} returns this
 */
proto.billing.private.paymentgateway.Response.prototype.setAvsCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string avs_message = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.Response.prototype.getAvsMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Response} returns this
 */
proto.billing.private.paymentgateway.Response.prototype.setAvsMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string cvv_code = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.Response.prototype.getCvvCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Response} returns this
 */
proto.billing.private.paymentgateway.Response.prototype.setCvvCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string cvv_message = 6;
 * @return {string}
 */
proto.billing.private.paymentgateway.Response.prototype.getCvvMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Response} returns this
 */
proto.billing.private.paymentgateway.Response.prototype.setCvvMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool pending = 7;
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Response.prototype.getPending = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.paymentgateway.Response} returns this
 */
proto.billing.private.paymentgateway.Response.prototype.setPending = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string error_code = 8;
 * @return {string}
 */
proto.billing.private.paymentgateway.Response.prototype.getErrorCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Response} returns this
 */
proto.billing.private.paymentgateway.Response.prototype.setErrorCode = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string error_detail = 9;
 * @return {string}
 */
proto.billing.private.paymentgateway.Response.prototype.getErrorDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Response} returns this
 */
proto.billing.private.paymentgateway.Response.prototype.setErrorDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool cancelled = 10;
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Response.prototype.getCancelled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.paymentgateway.Response} returns this
 */
proto.billing.private.paymentgateway.Response.prototype.setCancelled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string fraud_review = 11;
 * @return {string}
 */
proto.billing.private.paymentgateway.Response.prototype.getFraudReview = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Response} returns this
 */
proto.billing.private.paymentgateway.Response.prototype.setFraudReview = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional google.protobuf.Timestamp created_on = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billing.private.paymentgateway.Response.prototype.getCreatedOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billing.private.paymentgateway.Response} returns this
*/
proto.billing.private.paymentgateway.Response.prototype.setCreatedOn = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.Response} returns this
 */
proto.billing.private.paymentgateway.Response.prototype.clearCreatedOn = function() {
  return this.setCreatedOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Response.prototype.hasCreatedOn = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp updated_on = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billing.private.paymentgateway.Response.prototype.getUpdatedOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billing.private.paymentgateway.Response} returns this
*/
proto.billing.private.paymentgateway.Response.prototype.setUpdatedOn = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.Response} returns this
 */
proto.billing.private.paymentgateway.Response.prototype.clearUpdatedOn = function() {
  return this.setUpdatedOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Response.prototype.hasUpdatedOn = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.ShippingAddress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.ShippingAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.ShippingAddress.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    address1: jspb.Message.getFieldWithDefault(msg, 2, ""),
    address2: jspb.Message.getFieldWithDefault(msg, 3, ""),
    city: jspb.Message.getFieldWithDefault(msg, 4, ""),
    state: jspb.Message.getFieldWithDefault(msg, 5, ""),
    zip: jspb.Message.getFieldWithDefault(msg, 6, ""),
    country: jspb.Message.getFieldWithDefault(msg, 7, ""),
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.ShippingAddress}
 */
proto.billing.private.paymentgateway.ShippingAddress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.ShippingAddress;
  return proto.billing.private.paymentgateway.ShippingAddress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.ShippingAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.ShippingAddress}
 */
proto.billing.private.paymentgateway.ShippingAddress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress1(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress2(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setZip(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.ShippingAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.ShippingAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.ShippingAddress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddress1();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress2();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getZip();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.ShippingAddress} returns this
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string address1 = 2;
 * @return {string}
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.getAddress1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.ShippingAddress} returns this
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.setAddress1 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address2 = 3;
 * @return {string}
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.getAddress2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.ShippingAddress} returns this
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.setAddress2 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string city = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.ShippingAddress} returns this
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string state = 5;
 * @return {string}
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.ShippingAddress} returns this
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string zip = 6;
 * @return {string}
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.getZip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.ShippingAddress} returns this
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.setZip = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string country = 7;
 * @return {string}
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.ShippingAddress} returns this
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string phone_number = 8;
 * @return {string}
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.ShippingAddress} returns this
 */
proto.billing.private.paymentgateway.ShippingAddress.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.paymentgateway.ApiUrl.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.ApiUrl.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.ApiUrl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.ApiUrl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.ApiUrl.toObject = function(includeInstance, msg) {
  var f, obj = {
    referencingTransactionList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.ApiUrl}
 */
proto.billing.private.paymentgateway.ApiUrl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.ApiUrl;
  return proto.billing.private.paymentgateway.ApiUrl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.ApiUrl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.ApiUrl}
 */
proto.billing.private.paymentgateway.ApiUrl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addReferencingTransaction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.ApiUrl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.ApiUrl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.ApiUrl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.ApiUrl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReferencingTransactionList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string referencing_transaction = 1;
 * @return {!Array<string>}
 */
proto.billing.private.paymentgateway.ApiUrl.prototype.getReferencingTransactionList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billing.private.paymentgateway.ApiUrl} returns this
 */
proto.billing.private.paymentgateway.ApiUrl.prototype.setReferencingTransactionList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billing.private.paymentgateway.ApiUrl} returns this
 */
proto.billing.private.paymentgateway.ApiUrl.prototype.addReferencingTransaction = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.paymentgateway.ApiUrl} returns this
 */
proto.billing.private.paymentgateway.ApiUrl.prototype.clearReferencingTransactionList = function() {
  return this.setReferencingTransactionList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billing.private.paymentgateway.PaymentMethod.repeatedFields_ = [34];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.PaymentMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.PaymentMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.PaymentMethod.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdOn: (f = msg.getCreatedOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedOn: (f = msg.getUpdatedOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    email: jspb.Message.getFieldWithDefault(msg, 4, ""),
    data: (f = msg.getData()) && proto.billing.private.paymentgateway.Data.toObject(includeInstance, f),
    storageState: jspb.Message.getFieldWithDefault(msg, 6, ""),
    test: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    metadata: (f = msg.getMetadata()) && proto.billing.private.paymentgateway.Metadata.toObject(includeInstance, f),
    lastFourDigits: jspb.Message.getFieldWithDefault(msg, 9, ""),
    firstSixDigits: jspb.Message.getFieldWithDefault(msg, 10, ""),
    cardType: jspb.Message.getFieldWithDefault(msg, 11, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 12, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 13, ""),
    month: (f = msg.getMonth()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
    year: (f = msg.getYear()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
    address1: jspb.Message.getFieldWithDefault(msg, 16, ""),
    address2: jspb.Message.getFieldWithDefault(msg, 17, ""),
    city: jspb.Message.getFieldWithDefault(msg, 18, ""),
    state: jspb.Message.getFieldWithDefault(msg, 19, ""),
    zip: jspb.Message.getFieldWithDefault(msg, 20, ""),
    country: jspb.Message.getFieldWithDefault(msg, 21, ""),
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 22, ""),
    company: jspb.Message.getFieldWithDefault(msg, 23, ""),
    fullName: jspb.Message.getFieldWithDefault(msg, 24, ""),
    eligibleCardUpdater: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
    shippingAddress1: jspb.Message.getFieldWithDefault(msg, 26, ""),
    shippingAddress2: jspb.Message.getFieldWithDefault(msg, 27, ""),
    shippingCity: jspb.Message.getFieldWithDefault(msg, 28, ""),
    shippingState: jspb.Message.getFieldWithDefault(msg, 29, ""),
    shippingZip: jspb.Message.getFieldWithDefault(msg, 30, ""),
    shippingCountry: jspb.Message.getFieldWithDefault(msg, 31, ""),
    shippingPhoneNumber: jspb.Message.getFieldWithDefault(msg, 32, ""),
    paymentMethodType: jspb.Message.getFieldWithDefault(msg, 33, ""),
    errorsList: (f = jspb.Message.getRepeatedField(msg, 34)) == null ? undefined : f,
    fingerPrint: jspb.Message.getFieldWithDefault(msg, 35, ""),
    number: jspb.Message.getFieldWithDefault(msg, 36, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.PaymentMethod}
 */
proto.billing.private.paymentgateway.PaymentMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.PaymentMethod;
  return proto.billing.private.paymentgateway.PaymentMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.PaymentMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.PaymentMethod}
 */
proto.billing.private.paymentgateway.PaymentMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedOn(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedOn(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = new proto.billing.private.paymentgateway.Data;
      reader.readMessage(value,proto.billing.private.paymentgateway.Data.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStorageState(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTest(value);
      break;
    case 8:
      var value = new proto.billing.private.paymentgateway.Metadata;
      reader.readMessage(value,proto.billing.private.paymentgateway.Metadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastFourDigits(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstSixDigits(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardType(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMonth(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setYear(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress1(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress2(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setZip(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullName(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEligibleCardUpdater(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setShippingAddress1(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setShippingAddress2(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setShippingCity(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setShippingState(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setShippingZip(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setShippingCountry(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setShippingPhoneNumber(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethodType(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.addErrors(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setFingerPrint(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.PaymentMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.PaymentMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.PaymentMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedOn();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedOn();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.billing.private.paymentgateway.Data.serializeBinaryToWriter
    );
  }
  f = message.getStorageState();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTest();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.billing.private.paymentgateway.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getLastFourDigits();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFirstSixDigits();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCardType();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getMonth();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getYear();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getAddress1();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getAddress2();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getZip();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getFullName();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getEligibleCardUpdater();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getShippingAddress1();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getShippingAddress2();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getShippingCity();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getShippingState();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getShippingZip();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getShippingCountry();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getShippingPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getPaymentMethodType();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getErrorsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      34,
      f
    );
  }
  f = message.getFingerPrint();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getNumber();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created_on = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getCreatedOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
*/
proto.billing.private.paymentgateway.PaymentMethod.prototype.setCreatedOn = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.clearCreatedOn = function() {
  return this.setCreatedOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.hasCreatedOn = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp updated_on = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getUpdatedOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
*/
proto.billing.private.paymentgateway.PaymentMethod.prototype.setUpdatedOn = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.clearUpdatedOn = function() {
  return this.setUpdatedOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.hasUpdatedOn = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string email = 4;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional Data data = 5;
 * @return {?proto.billing.private.paymentgateway.Data}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getData = function() {
  return /** @type{?proto.billing.private.paymentgateway.Data} */ (
    jspb.Message.getWrapperField(this, proto.billing.private.paymentgateway.Data, 5));
};


/**
 * @param {?proto.billing.private.paymentgateway.Data|undefined} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
*/
proto.billing.private.paymentgateway.PaymentMethod.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.hasData = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string storage_state = 6;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getStorageState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setStorageState = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool test = 7;
 * @return {boolean}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getTest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setTest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional Metadata metadata = 8;
 * @return {?proto.billing.private.paymentgateway.Metadata}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getMetadata = function() {
  return /** @type{?proto.billing.private.paymentgateway.Metadata} */ (
    jspb.Message.getWrapperField(this, proto.billing.private.paymentgateway.Metadata, 8));
};


/**
 * @param {?proto.billing.private.paymentgateway.Metadata|undefined} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
*/
proto.billing.private.paymentgateway.PaymentMethod.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string last_four_digits = 9;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getLastFourDigits = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setLastFourDigits = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string first_six_digits = 10;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getFirstSixDigits = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setFirstSixDigits = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string card_type = 11;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getCardType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setCardType = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string first_name = 12;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string last_name = 13;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional google.protobuf.Int64Value month = 14;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getMonth = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 14));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
*/
proto.billing.private.paymentgateway.PaymentMethod.prototype.setMonth = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.clearMonth = function() {
  return this.setMonth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.hasMonth = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Int64Value year = 15;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getYear = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 15));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
*/
proto.billing.private.paymentgateway.PaymentMethod.prototype.setYear = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.clearYear = function() {
  return this.setYear(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.hasYear = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string address1 = 16;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getAddress1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setAddress1 = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string address2 = 17;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getAddress2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setAddress2 = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string city = 18;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string state = 19;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string zip = 20;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getZip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setZip = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string country = 21;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string phone_number = 22;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string company = 23;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setCompany = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string full_name = 24;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getFullName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setFullName = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional bool eligible_card_updater = 25;
 * @return {boolean}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getEligibleCardUpdater = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setEligibleCardUpdater = function(value) {
  return jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional string shipping_address1 = 26;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getShippingAddress1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setShippingAddress1 = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string shipping_address2 = 27;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getShippingAddress2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setShippingAddress2 = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string shipping_city = 28;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getShippingCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setShippingCity = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string shipping_state = 29;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getShippingState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setShippingState = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string shipping_zip = 30;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getShippingZip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setShippingZip = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string shipping_country = 31;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getShippingCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setShippingCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string shipping_phone_number = 32;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getShippingPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setShippingPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string payment_method_type = 33;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getPaymentMethodType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setPaymentMethodType = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * repeated string errors = 34;
 * @return {!Array<string>}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getErrorsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 34));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setErrorsList = function(value) {
  return jspb.Message.setField(this, 34, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.addErrors = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 34, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.clearErrorsList = function() {
  return this.setErrorsList([]);
};


/**
 * optional string finger_print = 35;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getFingerPrint = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setFingerPrint = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string number = 36;
 * @return {string}
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.getNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.PaymentMethod} returns this
 */
proto.billing.private.paymentgateway.PaymentMethod.prototype.setNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.Data.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.Data.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.Data} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.Data.toObject = function(includeInstance, msg) {
  var f, obj = {
    myPaymentMethodIdentifier: jspb.Message.getFieldWithDefault(msg, 1, ""),
    extraStuff: (f = msg.getExtraStuff()) && proto.billing.private.paymentgateway.ExtraStuff.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.Data}
 */
proto.billing.private.paymentgateway.Data.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.Data;
  return proto.billing.private.paymentgateway.Data.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.Data} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.Data}
 */
proto.billing.private.paymentgateway.Data.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMyPaymentMethodIdentifier(value);
      break;
    case 2:
      var value = new proto.billing.private.paymentgateway.ExtraStuff;
      reader.readMessage(value,proto.billing.private.paymentgateway.ExtraStuff.deserializeBinaryFromReader);
      msg.setExtraStuff(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.Data.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.Data.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.Data} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.Data.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMyPaymentMethodIdentifier();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExtraStuff();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.billing.private.paymentgateway.ExtraStuff.serializeBinaryToWriter
    );
  }
};


/**
 * optional string my_payment_method_identifier = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.Data.prototype.getMyPaymentMethodIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Data} returns this
 */
proto.billing.private.paymentgateway.Data.prototype.setMyPaymentMethodIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ExtraStuff extra_stuff = 2;
 * @return {?proto.billing.private.paymentgateway.ExtraStuff}
 */
proto.billing.private.paymentgateway.Data.prototype.getExtraStuff = function() {
  return /** @type{?proto.billing.private.paymentgateway.ExtraStuff} */ (
    jspb.Message.getWrapperField(this, proto.billing.private.paymentgateway.ExtraStuff, 2));
};


/**
 * @param {?proto.billing.private.paymentgateway.ExtraStuff|undefined} value
 * @return {!proto.billing.private.paymentgateway.Data} returns this
*/
proto.billing.private.paymentgateway.Data.prototype.setExtraStuff = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.Data} returns this
 */
proto.billing.private.paymentgateway.Data.prototype.clearExtraStuff = function() {
  return this.setExtraStuff(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Data.prototype.hasExtraStuff = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.ExtraStuff.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.ExtraStuff.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.ExtraStuff} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.ExtraStuff.toObject = function(includeInstance, msg) {
  var f, obj = {
    someOtherThings: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.ExtraStuff}
 */
proto.billing.private.paymentgateway.ExtraStuff.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.ExtraStuff;
  return proto.billing.private.paymentgateway.ExtraStuff.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.ExtraStuff} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.ExtraStuff}
 */
proto.billing.private.paymentgateway.ExtraStuff.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSomeOtherThings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.ExtraStuff.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.ExtraStuff.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.ExtraStuff} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.ExtraStuff.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSomeOtherThings();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string some_other_things = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.ExtraStuff.prototype.getSomeOtherThings = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.ExtraStuff} returns this
 */
proto.billing.private.paymentgateway.ExtraStuff.prototype.setSomeOtherThings = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billing.private.paymentgateway.Metadata.prototype.toObject = function(opt_includeInstance) {
  return proto.billing.private.paymentgateway.Metadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing.private.paymentgateway.Metadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.Metadata.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    anotherKey: (f = msg.getAnotherKey()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
    finalKey: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing.private.paymentgateway.Metadata}
 */
proto.billing.private.paymentgateway.Metadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billing.private.paymentgateway.Metadata;
  return proto.billing.private.paymentgateway.Metadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing.private.paymentgateway.Metadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing.private.paymentgateway.Metadata}
 */
proto.billing.private.paymentgateway.Metadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setAnotherKey(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFinalKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billing.private.paymentgateway.Metadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billing.private.paymentgateway.Metadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing.private.paymentgateway.Metadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billing.private.paymentgateway.Metadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAnotherKey();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getFinalKey();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.billing.private.paymentgateway.Metadata.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billing.private.paymentgateway.Metadata} returns this
 */
proto.billing.private.paymentgateway.Metadata.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Int64Value another_key = 2;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.billing.private.paymentgateway.Metadata.prototype.getAnotherKey = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.billing.private.paymentgateway.Metadata} returns this
*/
proto.billing.private.paymentgateway.Metadata.prototype.setAnotherKey = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billing.private.paymentgateway.Metadata} returns this
 */
proto.billing.private.paymentgateway.Metadata.prototype.clearAnotherKey = function() {
  return this.setAnotherKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Metadata.prototype.hasAnotherKey = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool final_key = 3;
 * @return {boolean}
 */
proto.billing.private.paymentgateway.Metadata.prototype.getFinalKey = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billing.private.paymentgateway.Metadata} returns this
 */
proto.billing.private.paymentgateway.Metadata.prototype.setFinalKey = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


goog.object.extend(exports, proto.billing.private.paymentgateway);
